<template>
    <div class="pagination text-center">
        <div class="divider divider-hidden stack-l"></div>
        <div class="btn-group justify-content-center stack-s" v-if="showPagination">
            <v-icon-button :disabled="!canMoveBackward" @click="moveToPreviousPage">
                <v-icon slot="left-icon" icon="arrow-left"></v-icon>
                Prev
            </v-icon-button>
            <template v-if="reachedMaxPagination">
                <div v-tooltip="{text: `Please refine your search to find the results you're looking for`}">
                    <v-icon-button disabled>
                        <r-icon slot="right-icon" icon="arrow-right" />
                        Next
                    </v-icon-button>
                </div>
            </template>
            <template v-else>
                <v-icon-button :disabled="!canMoveForward"
                               @click="moveToNextPage">
                    <r-icon slot="right-icon" icon="arrow-right" />
                    Next
                </v-icon-button>
            </template>
        </div>
        <slot
            name="paginationLabel"
            :startingRecord="startingRecord"
            :endingRecord="endingRecord"
            :total="total"
        >
            <template  v-if="showPagination">
                <span class="text-muted">{{startingRecord | number}}-{{endingRecord | number}} of {{total | number}}</span>
            </template>
            <template v-else>
                <span class="text-muted" v-if="total === 1">{{total | number}} record</span>
                <span class="text-muted" v-if="total > 1">{{total | number}} records</span>
            </template>
        </slot>
    </div>
</template>

<script>
    import {vIconButton, vIcon} from '@/components/form';

    const MAX_NAVIGABLE_PAGINATION = 1000;

    export default {
        name: 'v-pagination',
        components: {vIconButton, vIcon},
        props: {
            limit: {
                type: Number,
                default: 20,
            },
            offset: {
                type: Number,
                default: 0,
            },
            total: {
                type: Number,
                default: 0,
            },
            showPagination: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            currentPage() {
                return Math.floor(this.offset / this.limit) + 1;
            },
            totalPages() {
                return Math.ceil(this.total / this.limit);
            },
            startingRecord() {
                return this.offset + 1;
            },
            endingRecord() {
                const upperLimit = this.offset + this.limit;
                return upperLimit < this.total ? upperLimit : this.total;
            },
            canMoveBackward() {
                return this.currentPage > 1;
            },
            canMoveForward() {
                return !this.reachedMaxPagination && this.morePagesAvailable;
            },
            morePagesAvailable() {
                return this.currentPage < this.totalPages;
            },
            reachedMaxPagination() {
                return this.endingRecord >= MAX_NAVIGABLE_PAGINATION;
            },
        },
        methods: {
            moveToPreviousPage() {
                this.$emit('pagination-previous');
            },
            moveToNextPage() {
                this.$emit('pagination-next');
            },
        },
    };
</script>
